module.exports = __webpack_public_path__ + "static/media/logo-trustly.4dfd9018.svg";